<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="Ack">ACKNOWLEDGEMENTS</p>
<p class="noindent">Those who provided valuable input and suggestions include former lieutenant governor Bill Hobby, restaurateurs Bob and Carole Bogart, restaurateur Mariano Martinez, Sandra Lord of Discover Houston Tours, Whitney Deann Green, Don O’Neal, the late Tom Young, Lynne Deel, Bill Kittles, Betty Gore, Craig Hopkins, Larry Gillreath, Gayla Brooks, Joan Reisch, Linda Hynan, Frank Liberto of Rico Products, Charles R. Townsend (author of <i>San Antonio Rose: The Life and Music of Bob Wills</i> [Urbana: University of Illinois Press]), Cheryl Lindsay and Ritchie Eris of the Conrad N. Hilton Memorial Park and Community Center, Ed Spencer, James Gaskin, Jan Winebrenner, Terry R. Hauck, Robert Deevey, Amanda Raspberry (Dublin Dr Pepper), Emily Wynne of the Van Cliburn Foundation and the helpful folks at the Gladys City Boomtown Museum and Texas Energy Museum. There are probably some I’ve neglected to include in this list; I thank all who contributed to this project.</p>
<p class="indent">A special word of thanks to Patsy Summey for her numerous comments and suggestions. This project would not have been possible without the valuable help and support of my gracious and patient wife, E’Lynne Elliott.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?6895ac94